import React, {ChangeEventHandler} from 'react';

import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Text} from '@/src/ui';

import css from '../styles/ClinicVerificationDocument.module.css';

interface ClinicDocumentStatusProps {
  status: 'pending' | 'declined' | 'accepted';
  onUploadNewDocumentClick: ChangeEventHandler<HTMLInputElement>;
}

const ACCEPTED_FILES = '.jpg, .png, .jpeg, .pdf, .jpeg';
export const STATUSES = {
  ACCEPTED: 'approved',
  DECLINED: 'declined',
  PENDING: 'pending',
};

const ClinicVerificationDocumentStatusesLayout = ({
  status,
  onUploadNewDocumentClick,
}: ClinicDocumentStatusProps) => {
  return (
    <div className={css.documentStatuses}>
      {status === STATUSES.DECLINED && (
        <>
          <div>
            <label className={css.inputUploadFile} role="document-file">
              <input
                type="file"
                accept={ACCEPTED_FILES}
                onChange={onUploadNewDocumentClick}
              />
              <Button
                tagComponent={Button.TAG.SPAN}
                type={Button.TYPES.BUTTON}
                color={Button.COLOR.YELLOW}
                height={Button.HEIGHT.SMALL}
                border={Button.BORDER.BOLD}
              >
                <TextLocal id={'profile.reupload-certificate'} />
              </Button>
            </label>
          </div>

          <Text fontSize={Text.FONT_SIZE.SIZE_14} color={Text.COLOR.GREY}>
            <TextLocal id={'profile.certificate-been-expired'} />
          </Text>
        </>
      )}
      {status === STATUSES.ACCEPTED && (
        <Text
          color={Text.COLOR.GRADIENT}
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.BOLD}
        >
          <TextLocal id={'profile.document-accepted'} />
        </Text>
      )}
      {status === STATUSES.PENDING && (
        <>
          <Text
            color={Text.COLOR.ORANGE}
            fontSize={Text.FONT_SIZE.SIZE_16}
            fontWeight={Text.FONT_WEIGHT.BOLD}
          >
            <TextLocal id={'profile.pending-company-certificate'} />
          </Text>
          <Text fontSize={Text.FONT_SIZE.SIZE_14} color={Text.COLOR.GREY}>
            <TextLocal id={'profile.certificate-is-in-process'} />
          </Text>
        </>
      )}
    </div>
  );
};

export default ClinicVerificationDocumentStatusesLayout;
